import React from 'react'
import PropTypes from 'prop-types'
import { getSearchRadiusForGoogleMapsViewport } from '../../common/helpers/location_helper'
import { AVAILABLE_COUNTRY_CODES } from '../../common/constants/classifications'
import { withNamespaces } from "react-i18next"
import { compose } from 'redux'

class PlaceSearchBox extends React.Component {

  ref = React.createRef()

  componentDidMount() {
    /* global google */
    if (typeof google == 'undefined') {
      return
    }

    this.autoComplete = new google.maps.places.Autocomplete(this.ref.current, {
      componentRestrictions: {
        country: this.props.countryCode
      }
    })

    this.listener = this.autoComplete.addListener('place_changed', this.getPosition)
  }

  componentDidUpdate(prevProps) {
    if (this.props.destination !== prevProps.destination) {
      if (this.props.destination === '') {
        this.ref.current.value = ''
      }
    }
  }

  componentWillUnmount() {
    /* global google */
    if (typeof google == 'undefined') {
      return
    }
    google.maps.event.removeListener(this.listener)
    google.maps.event.clearInstanceListeners(this.autoComplete)
  }

  getPosition = () => {
    const place = this.autoComplete.getPlace()

    if (!place.geometry) return

    const { location } = place.geometry
    const radius = getSearchRadiusForGoogleMapsViewport(place.geometry.viewport)
    this.props.onPlaceChanged({
      name: place.name,
      lat: location.lat(),
      lon: location.lng(),
      radius
    })
  }

  render() {
    const { t } = this.props
    return (
      <div>
        <input
          name="destination"
          ref={this.ref}
          value={this.props.destination}
          onChange={(e) => {
            this.props.onPlaceChanged({
              name: e.target.value,
              lat: undefined,
              lon: undefined,
              radius: undefined
            })
          }}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          onKeyDown={(e) => {
            if (e.keyCode == '13') {
              this.props.onBlur()
            }
          }}
          type="text"
          placeholder={ t('search.search_conditions.filter.destination.place_search_box') }
        />
      </div>
    )
  }
}

PlaceSearchBox.propTypes = {
  destination: PropTypes.string.isRequired,
  onPlaceChanged: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onInputValueChange: PropTypes.func.isRequired,
  countryCode: PropTypes.string
}

export default compose( withNamespaces('search') )(PlaceSearchBox)
